import Joi from 'joi';

/**
 * Schema for agreement contact validation
 */
export const agreementContactSchema = () =>
  Joi.object({
    id: Joi.number().optional().allow(null),
    arrivalAt: Joi.date().optional().allow(null),
    arrivalAirportName: Joi.string().optional().allow(null, ''),
    arrivalFlightNumber: Joi.string().optional().allow(null, ''),
    departureAt: Joi.date().optional().allow(null),
    departureAirportName: Joi.string().optional().allow(null, ''),
    departureFlightNumber: Joi.string().optional().allow(null, ''),
    address1: Joi.string().optional().allow(null, ''),
    address2: Joi.string().optional().allow(null, ''),
    phoneLandline: Joi.string().optional().allow(null, ''),
    phoneMobile: Joi.string().optional().allow(null, ''),
    phoneFax: Joi.string().optional().allow(null, ''),
    city: Joi.string().optional().allow(null, ''),
    postCode: Joi.string().optional().allow(null, ''),
    poBox: Joi.string().optional().allow(null, ''),
    county: Joi.string().optional().allow(null, ''),
    state: Joi.string().optional().allow(null, ''),
    countryId: Joi.number().optional().allow(null),
  });
